import { Box, styled } from '@mui/material';
var StyledModalFooterContainer = styled(Box)(function (_ref) {
  var theme = _ref.theme;
  var styles = {
    padding: theme.spacing(3, 1.5)
  };
  return styles;
});
export { StyledModalFooterContainer };